import React,{useEffect,useState} from 'react';
import PropTypes from 'prop-types';
import Grid from '@mui/material/Grid';
import { useNavigate } from 'react-router-dom';
import httpClient from '../../httpClient';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import TextField from '@mui/material/TextField'
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import Fab from '@mui/material/Fab';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { testhttpClient } from '../../httpClient';
import { Autocomplete, Tooltip } from '@mui/material';
import  { useRef } from 'react';
import { dummyhttpClient } from '../../httpClient';
import CloseIcon from '@mui/icons-material/Close';
const UsecaseList = () => {
  const [usecase_dashboard_list,setusecase_dashboard_list] = useState([]);
  const [full_dashboard_list,set_full_dashboard_list] = useState([])
  const [disp_full_list,set_disp_full_list] = useState(false)
  const [disp_usecase_name,set_disp_usecase_name] = useState('')
  const [hide_usecase_index,set_hide_usecase_index] = useState(null)
  const [dashboard_list, setItems_dashboard_list] = useState([]);
  const targetDivRef = useRef(null);
  const [searchKey,setsearchKey] = useState("");
  const [loading, setLoading] = useState(true);
  const [expanded_usecase,setExpandedUsecase] = useState({})
  const [selected_id,set_selected_id] = useState(null)


  const dummy_list =[
    {
      'id':'option 1'
    },
    {
      'id':'option 2'
    }
  ]
  const enterKeyPress = (event,funct_trigg)=>{
    if (event.key === 'Enter') {
      event.preventDefault(); // Prevent the default form submission behavior
      //console.log('\n\nonenter pressed :: ',searchKey);
      handleSearch();
      // //console.log('key enter :: ')
      if(funct_trigg == 'usecase_list_search'){
        // //console.log('search list :: ')
        get_usecase_dashboard_list(searchKey);
      }
    }
  }

  function get_usecase_dashboard_list(newValue){
    // console.log("\nset search ::",newValue);
    newValue = (newValue != null) ? newValue : '';
    setsearchKey(newValue);
    const data = {
      token: localStorage.getItem('vector_token'),
      search_key: newValue,
      selected_usecase: expanded_usecase
    }
    testhttpClient.post('/get_usecase_dashboard_map_list',data).then(response=>{
      // console.log('response :: ',response)
      if(response.data.status == true){
        // //console.log('usecase data :: ',response.data.data)
        //console.log("p1");
        setusecase_dashboard_list(response.data.data);
        //console.log('usecase list ',usecase_dashboard_list)
        if(expanded_usecase!={}){
          // // //console.log('check sucess kkkkkk :: ',expanded_usecase.usecase_name)
          for(let i =0; i <response.data.data.length;i++){
            if(expanded_usecase.usecase_id == response.data.data[i].usecase_id){
              // //console.log(usecase_dashboard_list[i].usecase_name)
              set_full_dashboard_list(response.data.data[i].dashboard_list);
              set_hide_usecase_index(i);
            }
          }
        }

          // console.log("check last usecase :: ",localStorage.getItem('back_to_home_from_dashboard'));
          if(localStorage.getItem('back_to_home_from_dashboard')){
            let associatedUsecase = {};

            const usecase = response.data.data.find(each_usecase => each_usecase.usecase_id === parseInt(localStorage.getItem('back_to_home_from_dashboard')));
            // console.log("\n\nmatched usecase :: ",usecase);
            if (usecase) {
              // Retrieve the entire usecase object associated with the current item
              associatedUsecase = usecase;
              localStorage.removeItem('back_to_home_from_dashboard');
            }

            // console.log("set_backto_storedUsecase ::",associatedUsecase);
            if(associatedUsecase){
              disp_usecase(associatedUsecase);
            }
          }
        
      }
      else{
        // //console.log('failed response :: ',response)
      }
    })
    // //console.log('usecase list :: ',usecase_dashboard_list)
  }

  useEffect(() => {
    get_usecase_dashboard_list('');
  }, []
  ); 

  const titleCase = (input) => {
    if(input !== undefined){
      return input.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
    }else{
      return "Unknown";
    }
  };


const getFirstThreeLetterDashboardName = (statement) => {
    const words = statement.split(' ');
    const firstThreeWords = words.slice(0, 3);
    const firstLetters = firstThreeWords.map(word => word[0]);
    let dashboard_text = ''
    if (statement.length > 60) {
      if(statement.length<=80){
        dashboard_text = statement
      }else{
       dashboard_text = statement.slice(0, 80) + '...';
      }
      return [firstLetters.join(''),dashboard_text]
    }else {
        dashboard_text = statement;
      return [firstLetters.join(''),dashboard_text]
    }
  };

  const getFirstThreeLetterUsecaseName = (statement) =>{
    const words = statement.split(' ');
    const firstThreeWords = words.slice(0, 3);
    const firstLetters = firstThreeWords.map(word => word[0]);
    if (statement.length > 30) {
      const dashboard_text = statement.slice(0, 30) + '...';
      return [firstLetters.join(''),dashboard_text]
      } else {
        const dashboard_text = statement;
        return [firstLetters.join(''),dashboard_text]
      }
  }


  const getNextUsecaseColour = (() => {
    const colourList =["#F0FFFF","#FFFAF0","#DCDCDC","#FFFFF0","#E0FFFF","#B0C4DE"]
    let currentIndex = 0;
  
    return () => {
      const currentColour = colourList[currentIndex];
      currentIndex = (currentIndex + 1) % colourList.length; // Increment and wrap around
      return currentColour;
    };
  })();

  const getNextColor = (() => {
    const colorList = ["#4BB649", "#63DEF6", "#667FFF", "#66B3FF", "#8EE35B", "#B366FF", "#CA4242", "#FF6666", "#FF66B3", "#FF9966", "#FFC266", "#FFDD66"];
    let currentIndex = 0;
  
    return () => {
      const currentColor = colorList[currentIndex];
      currentIndex = (currentIndex + 1) % colorList.length; // Increment and wrap around
      return currentColor;
    };
  })();

  const navigate = useNavigate();
  const goToDashboard = (id,uId = null) =>{
    // Used for Back to home show in expanded view
    if(uId){
      localStorage.setItem('back_to_home_from_dashboard',uId);
    }else{
      localStorage.setItem('back_to_home_from_dashboard',expanded_usecase.usecase_id);
    }
    

    // //console.log("Dashboard call :: ",String(id))
    navigate(`/layout/Dashboard?id=${id}`);
   }

   

   const disp_usecase = (usecase) =>{
    // console.log("targetDivRef ::",targetDivRef);
    setExpandedUsecase(usecase)
    // console.log('usecase is :: ',usecase)
    set_full_dashboard_list(usecase.dashboard_list)
    // set_full_dashboard_list(usecase.dashboard_list)
    // console.log('full display list :: ',full_dashboard_list)
    const dash_list = usecase.dashboard_list
    // //console.log('other dash list :: ',dash_list)
    set_disp_usecase_name(usecase.usecase_name)
    set_disp_full_list(true)
    for(let i = 0;i<usecase_dashboard_list.length;i++){
      if(usecase_dashboard_list[i].usecase_id == usecase.usecase_id){
        set_hide_usecase_index(i)
      }
    }
    // window.scrollTo({top:0,behavior:'smooth'});
    targetDivRef.current.scrollIntoView({ behavior: 'smooth' });
   }

   const hide_usecase_disp = () =>{
    setExpandedUsecase({})
    set_disp_full_list(false)
    set_hide_usecase_index(null)
    // //console.log('disp status :: ',disp_full_list)
   }
  const [searchHistory, setSearchHistory] = useState([]);

  // Load search history from local storage on component mount
  useEffect(() => {
    const storedHistory = JSON.parse(localStorage.getItem('searchHistory')) || [];
    // //console.log("storedHistory :: ",storedHistory,typeof(storedHistory));
    setSearchHistory(storedHistory);
  }, []);

  function update_search_history(updatedHistory){
    const uniquesearch = Array.from(new Set(updatedHistory));
    setSearchHistory(uniquesearch);
    localStorage.setItem('searchHistory', JSON.stringify(uniquesearch))
  }

  // // Function to handle search
  const handleSearch = () => {
    //console.log("\n\nhandleSearch trigg :: ",searchKey);
    // Update search history
    if(searchKey.length){
      const updatedHistory = [searchKey, ...searchHistory.slice(0, 4)]; // Keep only last 5 searches
      update_search_history(updatedHistory);  
    }
    get_usecase_dashboard_list(searchKey);
  };

  function remove_recent_search(e,option){
    // console.log("remove_recent_search :: ",option,searchHistory);
    let updatedHistory = searchHistory.filter(e => e !== option);
    // console.log('updated hist :: ',updatedHistory);
    update_search_history(updatedHistory);
    e.stopPropagation();
  }

   function clearSearch(){
    setsearchKey("");
    get_usecase_dashboard_list("");
   }

return(
  <div className='alingItem' ref={targetDivRef}>
     <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 13 }}>
      <Grid item xs={10}>
        <Grid container spacing={2} columns={{ xs: 4, sm: 8, md: 13 }}>
          <Grid item xs={3}>
            <div className='dashBoardHeader'>
              My Dashboard
            </div>
          </Grid>
          <Grid item xs={9}>
            <div style={{float: 'left'}}>
              <Paper
                component="form"
                sx={{ display: 'flex', alignItems: 'center', width: '240px',borderRadius: '184px',height:'27px', padding: '4px 6px 4px 25px',backgroundColor: '#E5F6FF' }}
                >
                <Autocomplete
                  freeSolo
                  value={searchKey}
                  disableClearable
                  onChange={(event, newValue) => get_usecase_dashboard_list(newValue)}
                  options={searchHistory}
                  sx={{width:'95%'}}
                  size="small"
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      {option}
                      <IconButton sx={{right: 0,position: 'absolute'}} onClick={(e)=>remove_recent_search(e,option)} >
                        <CloseIcon sx={{fontSize:'20px'}} />
                      </IconButton>
                    </li>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="standard"
                      onChange={(event) => setsearchKey(event.target.value)}
                      onKeyDown={(e) => enterKeyPress(e,'usecase_list_search')}
                      placeholder='Search Dashboard'
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                          <>
                            {
                              (searchKey.length > 0) ? (
                                <IconButton onClick={clearSearch} edge="end" >
                                  <CloseIcon sx={{fontSize:'20px'}} />
                                </IconButton>) : null
                            }
                            <IconButton onClick={handleSearch} edge="end" >
                              <SearchIcon sx={{fontSize:'20px'}} />
                            </IconButton>
                          </>
                        ),
                      }}
                    />
                  )}
                />
              </Paper>
            <br/> 
            <br/>
        </div>
        </Grid>
        </Grid>
      </Grid>
      </Grid>
       

    {(disp_full_list == true) ? (
      <div  >
        <Card className='scrollable-all'sx={{ borderRadius: '8px', display: 'flex', overflow: 'hidden', height: '564px', width: '100%', '&:hover': { cursor: 'pointer' },overflowY:'auto'}} key={disp_usecase_name}>
          <CardContent>
              <Fab style={{backgroundColor:'white'}}  onClick={() => hide_usecase_disp()}>
                    <KeyboardBackspaceIcon />
              </Fab>
              <Typography sx={{ fontSize: 23, marginLeft:'80px',marginTop:'-40px'}} color="text.primary"  >
                  {titleCase(disp_usecase_name)}
              </Typography>            
            <div>
              <br/> <br/>
            <Grid container spacing={2}>
              {full_dashboard_list.map((each_dash,dash_index)=>{
                const randColor = getNextColor();
                const [threeLetters,dashboardText] = getFirstThreeLetterDashboardName(titleCase(each_dash.dd_name));
                const tooltipCheck = dashboardText.includes('...')
                return(
                  <Grid item xs={2} sm={4} md={4} key={dash_index + 'grid'}>
                    <Card sx={{ borderRadius: '8px', display: 'flex', overflow: 'hidden',height: '66px',width: '76%','&:hover': {cursor: 'pointer'} ,marginBottom: 1.5} } onClick={() => goToDashboard(each_dash.dd_id)}>
                      <div
                      style={{
                        flex: '20%',
                        backgroundColor: randColor, // Set your desired background color
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}>
                        <CardContent
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            textAlign: 'center', // Center text horizontally
                            lineHeight: '1.5',
                          }}
                        >

                          <Typography color="white">
                          <b>{threeLetters}</b>
                          </Typography>
                        </CardContent>
                      </div>
                      <div style={{ flex: '70%' }}>
                        {/* Content in the right partition */}
                        {(tooltipCheck || dashboardText.length >60) ?(
                                  <CardContent
                                  sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    padding:'7px 3px'
                                  }}>
                                    {tooltipCheck ?(
                                    <Tooltip title={each_dash.dd_name} arrow>
                                      <Typography variant="body1" fontSize={16} lineHeight={1.2}>
                                        {dashboardText}
                                      </Typography>
                                  </Tooltip>
                                  ):
                                  <Typography variant="body1" fontSize={16} lineHeight={1.2}>
                                  {dashboardText}
                                </Typography>
                                  }
                                    {/* <Tooltip title={each_dd.dd_name} arrow>
                                      <Typography variant="body1" fontSize={14} lineHeight={1.2}>
                                        {dashboardText}
                                      </Typography>
                                    </Tooltip> */}
                                  </CardContent>
                                  
                                ):
                                <CardContent
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  padding:'13px'
                                }}>
                                  {/* <Tooltip title={each_dash.dd_name} arrow> */}
                                    <Typography variant="body1" >
                                      {dashboardText}
                                    </Typography>
                                  {/* </Tooltip> */}
                                </CardContent>
                                }

                        {/* <CardContent
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                        }}>
                          
                          <Tooltip title = {each_dash.dd_name}>
                            <Typography variant="body1" fontSize={12}>
                              {dashboardText}
                            </Typography>
                          </Tooltip>
                        </CardContent> */}
                      </div>                      
                      </Card> 
                 </Grid>    
                )
              })}
               </Grid>
            </div>
          </CardContent>
        </Card>
        <br/>
      </div>
    ):null}
  <Grid container spacing={{ xs: 2, md: 2 }} columns={{ xs: 6, sm: 8, md: 13 }}>
    {usecase_dashboard_list.map((each_usecase, index) => {
      const randColour = getNextUsecaseColour();
      const [threeLetters,usecaseText] = getFirstThreeLetterUsecaseName(titleCase(each_usecase.usecase_name));
      const tooltipCheck = usecaseText.includes('...')
      // // //console.log('tool tip cehck ::  ',tooltipCheck)
      if(index != hide_usecase_index && each_usecase.dashboard_list.length > 0){
        return (
          <Grid item xs={2} sm={4} md={4} key={index + 'grid'}>
            <Card sx={{ borderRadius: '8px', display: 'flex', overflow: 'hidden', height: '387px', width: '100%', '&:hover': { cursor: 'pointer' } }}>
              <div
                style={{
                  flex: '20%',
                  backgroundColor: randColour,
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <CardContent>
                  <div style={{height:'10%'}}>
                    {  tooltipCheck ? (<Tooltip title={titleCase(each_usecase.usecase_name)} arrow placement='top'>
                      <Typography sx={{ fontSize: 19 }} color="text.primary" gutterBottom height={'50px'}>
                        {usecaseText}
                      </Typography>
                    </Tooltip>):
                    <Typography sx={{ fontSize: 19 }} color="text.primary" gutterBottom height={'50px'}>
                        {usecaseText}
                      </Typography>}
                    {/* <Tooltip title={each_usecase.usecase_name}>
                      <Typography sx={{ fontSize: 19 }} color="text.primary" gutterBottom height={'50px'}>
                        {usecaseText}
                      </Typography>
                    </Tooltip> */}
                  </div>
                  <div style={{height:'80%'}}>
                    <Grid container spacing={{ xs: 1 }}>
                      {each_usecase.dashboard_list.map((each_dd, dd_index) => { 
                        const randColor = getNextColor();
                        const [threeLetters,dashboardText] = getFirstThreeLetterDashboardName(titleCase(each_dd.dd_name));
                        const tooltipCheck = dashboardText.includes('...')
                        if (dd_index <4){return (
                          <Grid item xs = {12}>
                            <Card sx={{ borderRadius: '8px', display: 'flex', overflow: 'hidden',height: '66px',width: '100%','&:hover': {cursor: 'pointer'}, }} onClick={() => goToDashboard(each_dd.dd_id,each_usecase.usecase_id)}>
                              <div
                              style={{
                                flex: '20%',
                                backgroundColor: randColor, // Set your desired background color
                                alignItems: 'center',
                                justifyContent: 'center',
                              }}>
                                <CardContent
                                  sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    textAlign: 'center', // Center text horizontally
                                    lineHeight: '1.5',
                                  }}
                                >
                                  <Typography color="white">
                                  <b>{threeLetters}</b>
                                  </Typography>
                                </CardContent>
                              </div>
                              <div style={{ flex: '70%' }} >
                                {/* Content in the right partition */}
                                {(tooltipCheck || dashboardText.length >60) ?(
                                  <CardContent
                                  sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    padding:'7px 12px'
                                  }}>
                                    {tooltipCheck ?(
                                    <Tooltip title={each_dd.dd_name} arrow>
                                    <Typography variant="body1" fontSize={14} lineHeight={1.2}>
                                      {dashboardText}
                                    </Typography>
                                  </Tooltip>
                                  ):
                                  <Typography variant="body1" fontSize={14} lineHeight={1.2}>
                                  {dashboardText}
                                </Typography>
                                  }
                                    {/* <Tooltip title={each_dd.dd_name} arrow>
                                      <Typography variant="body1" fontSize={14} lineHeight={1.2}>
                                        {dashboardText}
                                      </Typography>
                                    </Tooltip> */}
                                  </CardContent>
                                  
                                ):
                                <CardContent
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  padding:'13px'
                                }}>
                                  {/* <Tooltip title={each_dd.dd_name} arrow> */}
                                    <Typography variant="body1">
                                      {dashboardText}
                                    </Typography>
                                  {/* </Tooltip> */}
                                </CardContent>
                                }
                              </div>                      
                            </Card> 
                          </Grid> 
                        )};
                        return null;
                      
                      })}
                    </Grid>
                    
                  </div>
                  <div style={{height:'10%'}}>
                  {each_usecase.dashboard_list.length > 4 && (
                          <Typography onClick={() => disp_usecase(each_usecase)} color="blue" >
                            See all ({each_usecase.dashboard_list.length})
                          </Typography>
                    )}                
                    </div>
                </CardContent>
              </div>
            </Card>
          </Grid>
        );
      }
    })}
  </Grid>
</div>
  )
}

UsecaseList.propTypes = {};

UsecaseList.defaultProps = {};

export default UsecaseList;